"use strict";
//#region imports
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBAuthTokenIntegration = void 0;
var csrf_xhr_1 = require("../shared/csrf-xhr");
var auth_cross_domain_iframe_1 = require("./auth-cross-domain-iframe");
var auth_domain_1 = require("./auth-domain");
//#endregion
var BBAuthTokenIntegration = /** @class */ (function () {
    function BBAuthTokenIntegration() {
    }
    BBAuthTokenIntegration.getToken = function (disableRedirect, envId, permissionScope, leId, svcId) {
        if (auth_domain_1.BBAuthDomain.getRegisteredDomain() === undefined &&
            !this.hostNameEndsWith('blackbaud.com')) {
            return auth_cross_domain_iframe_1.BBAuthCrossDomainIframe.getToken({
                disableRedirect: disableRedirect,
                envId: envId,
                leId: leId,
                permissionScope: permissionScope,
                svcId: svcId
            });
        }
        return csrf_xhr_1.BBCsrfXhr.request(auth_domain_1.BBAuthDomain.getSTSDomain() + '/oauth2/token', undefined, disableRedirect, envId, permissionScope, leId, true, svcId);
    };
    BBAuthTokenIntegration.hostNameEndsWith = function (domain) {
        return this.getLocationHostname().substr(-domain.length) === domain;
    };
    // wrapper for window.location.hostName so it can be tested.
    BBAuthTokenIntegration.getLocationHostname = function () {
        return window.location.hostname;
    };
    return BBAuthTokenIntegration;
}());
exports.BBAuthTokenIntegration = BBAuthTokenIntegration;
